//$(function () {
//    menu_trigger = $('.nav-toggle');
//    nav = $('.nav');
//    body = $('body');
//    nav_icon = $('.nav__icon');

//    menu_trigger.click(function () {
//        $(this).toggleClass('nav-toggle--active');
//        nav.toggleClass('nav--active');
//        body.toggleClass('body--overlay');

//        if ($(this).attr('aria-expanded') === 'true') {
//            $(this).attr('aria-expanded', 'false');
//        } else {
//            $(this).attr('aria-expanded', 'true');
//        }
//    });

//    nav_icon.click(function () {
//        $(this).toggleClass('nav__icon--active');
//        $(this).closest('.nav__item').find('.nav__dropdown').toggleClass('nav__dropdown--active');
//    });

//    // Close mobile nav by click outside
//    $(document).mouseup(function (e) {
//        if (!nav.is(e.target) && !menu_trigger.is(e.target) && nav.has(e.target).length === 0) {
//            menu_trigger.removeClass('nav-toggle--active');
//            nav.removeClass('nav--active');
//            body.removeClass('body--overlay');
//        }
//    });
//});
function initScroll() {
    addEventListener("scroll", (event) => { showHeader(); });
}

function showHeader() {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
    var headerSmall = document.querySelector(".header--small");

    var scrollTop = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    if (scrollTop >= 100) {
        headerSmall.classList.add("header--small--show");
    } else {
        headerSmall.classList.remove("header--small--show");
    }
}

function initNav() {
    document.querySelectorAll('.nav__item--parent').forEach(function (e) {
        if (e.querySelectorAll(".nav__dropdown").length > 0) {
            e.classList.add("nav__item-has-dropdown");
        }
    });

    var menuTrigger = document.getElementById("menuTrigger");
    var nav = document.getElementById("topNav");
    var body = document.body;
    menuTrigger.addEventListener('click', function (event) {
        menuTrigger.classList.toggle('menu-trigger--active');
        nav.classList.toggle('nav--open');
        body.classList.toggle('no-scroll')
    }, false);
    var topHamburger = document.getElementById("topHamburger");

    if (topHamburger != null) {
        topHamburger.addEventListener('click', function (event) {
            var dropdown = document.getElementById("extraDropdown");
            if (dropdown.classList.contains("active")) {
                dropdown.classList.remove("active")
            }
            else {
                dropdown.classList.add("active");
            }
        }, false);
    }
}
initNav();
initScroll();